import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ReactNotification from 'react-notifications-component';
import Loading from 'react-loading-bar';

import Mainview from '../Mainview/Mainview';
import Sidebar from '../Navigation/Sidebar';
import Geocoder from '../Geocoder/Geocoder';
import Modal from '../Modal/Modal';
import LayerSwitchItem from '../Navigation/Layerswitchitem';
import SightingsItem from '../Navigation/Sightingsitem';
import ExportItem from '../Navigation/Exportitem';
import Accountitem from '../Navigation/Accountitem';
import MapKey from '../MapKey/MapKey';

import { reAuthUser, getApplicationLinks } from '../../actions/app/app';

const App = () => {

  const dispatch = useDispatch(),
        appProps = useSelector(store => store.app),
        [map, setMap] = useState(null);

  useEffect(() => {
    dispatch(reAuthUser());
    dispatch(getApplicationLinks());
  }, [dispatch]);

  return (
    <Mainview setMap={ setMap } map={ map }>

      <Loading
        show={ appProps.loading }
        showSpinner={ false }
        color="#2980b9" />
      
      <Sidebar>
        <Accountitem />
        <SightingsItem />
        <LayerSwitchItem />
        <ExportItem mapCanvas={ map?.getCanvas() } />
      </Sidebar>

      <Geocoder mapCenter={ map?.getCenter() } countryLimit="au" />
      
      <ReactNotification />

      <Modal map={ map } />
      
      <MapKey />

    </Mainview>
  );

}

export default App;